// Components==============
import NavigationBox from 'components/Layout/NavigationBox/NavigationBox';
import React, { useContext, useRef } from 'react';
import { HomeContext } from 'screens/Home/Home';
import { useOnClickOutside } from 'utilities/useOnClickOutside';
import './TrophyModal.module.scss';
// =========================

const trophies = [
    { id: 0, title: 'none', text: '', image: 'none' },
    {
        id: 1,
        title: 'Spiek',
        text:
            'Dit is het eerste standbeeld. Deze heb je in je tuin gekregen omdat je goed geoefend hebt en nieuwe dingen hebt geleerd. Ga verder om je beeldentuin voller te maken!',
        image: '/images/trophies/spiek.svg',
    },
    {
        id: 2,
        title: 'Beer met kapotte bel',
        text:
            'Je hebt met verschillende bijna wat ik hoor woorden geoefend. Daarom krijg je dit standbeeld van een beer heeft een kapotte bel om zijn arm. Beer van eer, eur, oor woorden en de kapotte bel net als de kapotte bel van Spiek bij de bijna wat ik hoor woorden. Ga verder om je beeldentuin groter te maken!',
        image: '/images/trophies/beer.svg',
    },
    {
        id: 3,
        title: 'Plaksel met riem',
        text:
            'Dit standbeeld heb je gekregen omdat je met alle regelwoorden van de voorkant van de spiekbrief hebt geoefend. Ook oefen je nu met steeds langere woorden, vaak plakwoorden. Je ziet hier plaksel, van de plakwoorden, met een riem om, van de regelwoorden. Ga verder om je beeldentuin groter te maken!',
        image: '/images/trophies/lijm.svg',
    },
    {
        id: 4,
        title: 'Lange en korte klankenmachine',
        text:
            'De korte en lange klankenregel heb je nu veel geoefend, daarom krijg je dit standbeeld. Herken je de twee machines? Ga verder om je beeldentuin groter te maken!',
        image: '/images/trophies/lab.svg',
    },
    {
        id: 5,
        title: 'Panda met cactus-je',
        text:
            'Dit standbeeld heb je gekregen omdat je verschillende regelwoorden hebt herhaald, bijvoorbeeld de lange klank aan het eind van het woord, net als bij panda. Daarnaast heb je met bijna wat ik hoor woorden geoefend uit de wondere woorden woestijn, herken je de cactus in de vorm van -je? Ga verder om je beeldentuin groter te maken!',
        image: '/images/trophies/plateau.svg',
    },
    {
        id: 6,
        title: 'Pauw en ei',
        text:
            'Dit standbeeld heb je gekregen omdat je met lange regelwoorden en weetwoorden hebt geoefend. Dit standbeeld helpt je om de weetwoorden met ei en au te onthouden. Ga verder om je beeldentuin groter te maken!',
        image: '/images/trophies/ei.svg',
    },
    {
        id: 7,
        title: 'Taxi met piepers',
        text:
            'Je hebt met verschillende regels en lange woorden geoefend. Daarom krijg je dit standbeeld van de taxi. Herken jij de regel van drie kilo piepers in een taxi? Ga verder om je beeldentuin groter te maken!',
        image: '/images/trophies/auto.svg',
    },
    {
        id: 8,
        title: 'Circus op punaise',
        text:
            'Dit standbeeld heb je gekregen omdat je met veel weetwoorden hebt geoefend. Herken je het circus van woorden met een c en punaise van woorden met aise? Ga verder om je beeldentuin groter te maken!',
        image: '/images/trophies/circus.svg',
    },
    {
        id: 9,
        title: 'Spacewereld',
        text:
            'Je hebt met veel leenwoorden geoefend, daarom krijg je dit standbeeld van de spacewereld. Je beeldentuin is nu compleet! Wat heb jij hard gewerkt!',
        image: '/images/trophies/planeet.svg',
    },
];

export default function TrophyModal() {
    const { selectedTrophy, setSelectedTrophy } = useContext(HomeContext);

    const ref = useRef<HTMLDivElement>(null);

    useOnClickOutside(ref, () => setSelectedTrophy(0));

    return (
        <NavigationBox
            displayMode="centered"
            title={trophies[selectedTrophy].title}
            text={trophies[selectedTrophy].text}
            image={trophies[selectedTrophy].image}
            animations
            reference={ref}
        />
    );
}
